import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"600px","padding-top":"6em"}},[_c(VRow,{attrs:{"justify":"center"}},[_vm._v(" Your account access has been disabled. Please contact Social Standards for help. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }